import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "call-dialog__calling-state"
}
const _hoisted_2 = { class: "call-dialog__calling-content" }
const _hoisted_3 = { class: "call-dialog__calling-avatar" }
const _hoisted_4 = { class: "call-dialog__calling-avatar-inner" }
const _hoisted_5 = { class: "call-dialog__calling-initials" }
const _hoisted_6 = { class: "call-dialog__calling-info" }
const _hoisted_7 = { class: "call-dialog__calling-title" }
const _hoisted_8 = { class: "call-dialog__calling-timer" }
const _hoisted_9 = { class: "call-dialog__breakthrough-content" }
const _hoisted_10 = { class: "call-dialog__breakthrough-icon" }
const _hoisted_11 = { class: "call-dialog__breakthrough-reasons" }
const _hoisted_12 = { class: "call-dialog__breakthrough-options" }
const _hoisted_13 = ["onClick", "onKeydown"]
const _hoisted_14 = { class: "call-dialog__breakthrough-option-text" }
const _hoisted_15 = {
  key: 0,
  class: "call-dialog__other-input-wrapper"
}
const _hoisted_16 = {
  key: 3,
  class: "call-dialog__completed-state"
}
const _hoisted_17 = { class: "call-dialog__completed-header" }
const _hoisted_18 = { class: "call-dialog__completed-title" }
const _hoisted_19 = { class: "call-dialog__completed-patient" }
const _hoisted_20 = { class: "call-dialog__completed-status" }
const _hoisted_21 = {
  key: 0,
  class: "call-dialog__discharge-badge"
}
const _hoisted_22 = { class: "call-dialog__completed-sections" }
const _hoisted_23 = { class: "call-dialog__section" }
const _hoisted_24 = ["onKeydown"]
const _hoisted_25 = { class: "call-dialog__completed-participants" }
const _hoisted_26 = { class: "call-dialog__completed-participant" }
const _hoisted_27 = { class: "call-dialog__avatar" }
const _hoisted_28 = { class: "call-dialog__participant-info" }
const _hoisted_29 = { class: "call-dialog__participant-name" }
const _hoisted_30 = { class: "call-dialog__section" }
const _hoisted_31 = ["onKeydown"]
const _hoisted_32 = { class: "call-dialog__completed-details" }
const _hoisted_33 = { class: "call-dialog__detail-row" }
const _hoisted_34 = { class: "call-dialog__detail-value" }
const _hoisted_35 = { class: "call-dialog__detail-row" }
const _hoisted_36 = { class: "call-dialog__detail-value" }
const _hoisted_37 = { class: "call-dialog__detail-row" }
const _hoisted_38 = { class: "call-dialog__detail-value" }
const _hoisted_39 = { class: "call-dialog__detail-row" }
const _hoisted_40 = { class: "call-dialog__detail-value" }
const _hoisted_41 = { class: "call-dialog__section" }
const _hoisted_42 = { class: "call-dialog__feedback-section" }
const _hoisted_43 = { class: "call-dialog__completed-footer" }
const _hoisted_44 = {
  key: 0,
  class: "call-dialog__footer-actions"
}
const _hoisted_45 = {
  key: 1,
  class: "call-dialog__footer-actions call-dialog__footer-actions--feedback"
}
const _hoisted_46 = {
  key: 4,
  class: "call-dialog__not-answered-state"
}
const _hoisted_47 = { class: "call-dialog__not-answered-content" }
const _hoisted_48 = { class: "call-dialog__not-answered-icon" }
const _hoisted_49 = { class: "call-dialog__not-answered-info" }
const _hoisted_50 = { class: "call-dialog__not-answered-subtitle" }
const _hoisted_51 = { class: "call-dialog__not-answered-actions" }
const _hoisted_52 = { class: "call-dialog__breakthrough-section" }
const _hoisted_53 = {
  key: 5,
  class: "call-dialog__content"
}
const _hoisted_54 = { class: "call-dialog__header" }
const _hoisted_55 = { class: "call-dialog__title" }
const _hoisted_56 = { class: "call-dialog__patient-name" }
const _hoisted_57 = { class: "call-dialog__status-column" }
const _hoisted_58 = {
  key: 0,
  class: "call-dialog__discharge-badge"
}
const _hoisted_59 = {
  key: 1,
  class: "call-dialog__overdue-badge"
}
const _hoisted_60 = { class: "call-dialog__scrollable-content" }
const _hoisted_61 = { class: "call-dialog__section" }
const _hoisted_62 = ["onKeydown"]
const _hoisted_63 = { class: "call-dialog__participants" }
const _hoisted_64 = { class: "call-dialog__participant" }
const _hoisted_65 = { class: "call-dialog__avatar-wrapper" }
const _hoisted_66 = { class: "call-dialog__avatar" }
const _hoisted_67 = { class: "call-dialog__participant-info" }
const _hoisted_68 = { class: "call-dialog__participant-name" }
const _hoisted_69 = { class: "call-dialog__participant" }
const _hoisted_70 = { class: "call-dialog__avatar-wrapper" }
const _hoisted_71 = { class: "call-dialog__avatar call-dialog__avatar--nurse" }
const _hoisted_72 = { class: "call-dialog__participant-info" }
const _hoisted_73 = { class: "call-dialog__participant-name" }
const _hoisted_74 = { class: "call-dialog__action-buttons" }
const _hoisted_75 = { class: "call-dialog__section" }
const _hoisted_76 = ["onKeydown"]
const _hoisted_77 = { class: "call-dialog__participants" }
const _hoisted_78 = { class: "call-dialog__participant" }
const _hoisted_79 = { class: "call-dialog__participant" }
const _hoisted_80 = { class: "call-dialog__action-buttons" }
const _hoisted_81 = { class: "call-dialog__footer" }

import { computed, ref, watch, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import type { Patient } from "@virtual-care/shared";
import { signalingService } from "../services/signalingService";
import { callApiClient } from "../services/callApiClient";
import { useCallStore } from "../store/callStore";
import { usePatientStore } from "../store/patientStore";
import { formatElapsedTime, formatOverdueTime } from "../utils/timeFormat";

interface Props {
  modelValue: boolean;
  patientInfo?: Patient | null;
  showBreakthrough?: boolean;
}

interface Emits {
  (e: "update:modelValue", value: boolean): void;
  (e: "confirm"): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallDialog',
  props: {
    modelValue: { type: Boolean },
    patientInfo: { default: null },
    showBreakthrough: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const router = useRouter();
const callStore = useCallStore();
const patientStore = usePatientStore();

// Derive patientId from roomId stored in callStore (roomId alone is not PHI).
// Must be called BEFORE callStore.endCall() which nulls out roomId.
const refreshCallLogFromRoomId = () => {
  const roomId = callStore.roomId;
  if (!roomId) return;
  const patient = patientStore.patients.find((p) => p.room.roomId === roomId);
  if (patient) {
    patientStore.refreshPatientCallLog(patient.patientId).catch(() => {});
  }
};

const breakthroughStateRef = ref<HTMLElement | null>(null);
const callParticipantsExpanded = ref(true);
const carePartnersExpanded = ref(true);
const callDetailsExpanded = ref(true);
const feedbackExpanded = ref(false);
const callState = ref<"ready" | "calling" | "not-answered" | "breakthrough" | "completed">("ready");
const previousState = ref<"ready" | "not-answered">("ready");
const callDuration = ref(0);
const callAttempts = ref(1);
const callEndTime = ref("");
const callStartTime = ref("");
const callOutcome = ref("");
const selectedBreakthroughReason = ref<string | null>(null);
const showOtherInput = ref(false);
const otherReasonText = ref("");
const feedbackText = ref("");
const isBreakthroughInProgress = ref(false);
const isCancelling = ref(false); // Prevent state changes during cancellation
const showError = ref(false);
const errorMessage = ref("");
let timerInterval: number | null = null;
let noAnswerTimeout: number | null = null;

// Get current user info from localStorage
const currentUserDisplayName = computed(() => {
  return localStorage.getItem('vc_display_name') || 'Unknown User';
});

const currentUserInitials = computed(() => {
  const name = currentUserDisplayName.value;
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
});

watch(otherReasonText, () => {
  if (otherReasonText.value && breakthroughStateRef.value) {
    setTimeout(() => {
      breakthroughStateRef.value?.scrollTo({
        top: breakthroughStateRef.value.scrollHeight,
        behavior: "smooth",
      });
    }, 100);
  }
});

const breakthroughReasons = [
  { id: "sla-breach", label: "SLA Breach – Discharge Overdue" },
  { id: "clinical-need", label: "Time-Sensitive Clinical Need" },
  { id: "transportation", label: "Transportation / DME Arrived" },
  { id: "other", label: "Other" },
];

const toggleCallParticipants = () => {
  callParticipantsExpanded.value = !callParticipantsExpanded.value;
};

const toggleCarePartners = () => {
  carePartnersExpanded.value = !carePartnersExpanded.value;
};

const startTimer = () => {
  callDuration.value = 0;
  timerInterval = window.setInterval(() => {
    callDuration.value++;
  }, 1000);
};

const stopTimer = () => {
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
  if (noAnswerTimeout) {
    clearTimeout(noAnswerTimeout);
    noAnswerTimeout = null;
  }
};

const removeSocketListeners = () => {
  signalingService.off("call_accepted", onCallAccepted);
  signalingService.off("call_declined", onCallDeclined);
  signalingService.off("call_ended", onCallEnded);
};

const onCallAccepted = () => {
  removeSocketListeners();
  stopTimer();
  const sessionId = callStore.sessionId;
  if (sessionId) {
    router.push(`/nurse-console/call/${sessionId}`);
    emit('update:modelValue', false); // Close the dialog
  }
};

const onCallDeclined = () => {
  // Ignore if we're actively cancelling (prevents flash)
  if (isCancelling.value) {
    console.log('[CallDialog] Ignoring call_declined during cancellation');
    return;
  }
  
  removeSocketListeners();
  stopTimer();
  isBreakthroughInProgress.value = false; // Reset so user can retry
  // Refresh before any store reset that would clear roomId
  refreshCallLogFromRoomId();
  const now = new Date();
  callEndTime.value = now.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  callState.value = "not-answered";
};

const onCallEnded = () => {
  // Ignore if we're actively cancelling (prevents flash)
  if (isCancelling.value) {
    console.log('[CallDialog] Ignoring call_ended during cancellation');
    return;
  }
  
  removeSocketListeners();
  stopTimer();
  isBreakthroughInProgress.value = false; // Reset so user can retry
  // Refresh before any store reset that would clear roomId
  refreshCallLogFromRoomId();
  const now = new Date();
  callEndTime.value = now.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  callState.value = "completed";
};

const registerSocketListeners = () => {
  signalingService.on("call_accepted", onCallAccepted);
  signalingService.on("call_declined", onCallDeclined);
  signalingService.on("call_ended", onCallEnded);
};

onBeforeUnmount(() => {
  removeSocketListeners();
  stopTimer();
});

const formattedDuration = computed(() => {
  const minutes = Math.floor(callDuration.value / 60);
  const seconds = callDuration.value % 60;
  return `${minutes}m ${seconds}s`;
});

const formattedCallDuration = computed(() => {
  const minutes = Math.floor(callDuration.value / 60);
  const seconds = callDuration.value % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
});

const formattedCallDurationFull = computed(() => {
  const hours = Math.floor(callDuration.value / 3600);
  const minutes = Math.floor((callDuration.value % 3600) / 60);
  const seconds = callDuration.value % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
});

watch(
  () => props.modelValue,
  async (newVal) => {
    console.log('[CallDialog] modelValue changed:', newVal, 'showBreakthrough:', props.showBreakthrough);
    if (!newVal) {
      // Dialog closing - clean up everything
      removeSocketListeners(); // Extra safeguard to prevent any late events
      stopTimer();
      callState.value = "ready";
      callDuration.value = 0;
      callAttempts.value = 1;
      isCancelling.value = false; // Reset cancelling flag
    } else if (newVal && props.showBreakthrough) {
      console.log('[CallDialog] Opening in breakthrough mode');
      callState.value = "breakthrough";
      previousState.value = "ready";
    }
    // Normal call opens in "ready" state - nurse must click "Call Now" button
  }
);

const patientInitials = computed(() => {
  if (!props.patientInfo?.patientName) return "SJ";
  const names = props.patientInfo.patientName.split(" ");
  if (names.length >= 2) {
    return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
  }
  return props.patientInfo.patientName.substring(0, 2).toUpperCase();
});

const displayReason = computed(() => {
  if (!props.patientInfo?.reason) return "";
  
  // For conditional discharge, show category with reason in parentheses
  if (props.patientInfo.status === "condition-discharge") {
    return `Conditional Discharge (${props.patientInfo.reason})`;
  }
  
  // For other statuses, show reason as-is
  return props.patientInfo.reason;
});

const statusBadgeColor = computed(() => {
  if (!props.patientInfo) return "#EEF5EF";
  if (props.patientInfo.status === "discharge-ready") {
    return "#EEF5EF";
  } else if (props.patientInfo.status === "condition-discharge") {
    return "#FEF3E8";
  } else if (props.patientInfo.status === "new-admit") {
    return "#E8EEFB";
  }
  return "#EEF5EF";
});

const statusBadgeTextColor = computed(() => {
  if (!props.patientInfo) return "#25883B";
  if (props.patientInfo.status === "discharge-ready") {
    return "#25883B";
  }
  return "#222222";
});

const formatDischargeTime = computed(() => {
  return formatElapsedTime(props.patientInfo?.dischargeOrderTime);
});

const overdueMinutes = computed(() => {
  if (!props.patientInfo?.dischargeOrderTime || !props.patientInfo?.isOverdue) return '';
  return formatOverdueTime(props.patientInfo.dischargeOrderTime);
});

const handleClose = () => {
  removeSocketListeners();
  stopTimer();
  callState.value = "ready";
  callDuration.value = 0;
  feedbackExpanded.value = false;
  feedbackText.value = "";
  emit("update:modelValue", false);
};

const primeCallAudioContext = async () => {
  if (typeof window === "undefined") return;

  try {
    const AudioContextCtor =
      window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioContextCtor) return;

    // Keep a shared context alive so later SDK audio operations don't depend on
    // route-mounted code being inside a click handler.
    const win = window as unknown as { __vcCallAudioContext?: AudioContext };
    if (!win.__vcCallAudioContext) {
      win.__vcCallAudioContext = new AudioContextCtor();
    }

    const ctx = win.__vcCallAudioContext;
    if (ctx.state === "suspended") {
      await ctx.resume();
    }

    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    gain.gain.value = 0.00001;
    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.start();
    oscillator.stop(ctx.currentTime + 0.01);
  } catch (err) {
    console.warn("[CallDialog] Audio context prime failed:", err);
  }
};

const handleConfirm = async () => {
  console.log('[CallDialog] handleConfirm called');
  await primeCallAudioContext();
  callState.value = "calling";
  startTimer();
  registerSocketListeners();
  console.log('[CallDialog] Emitting confirm event');
  emit("confirm");
};

const handleCancelCall = async () => {
  console.log('[CallDialog] handleCancelCall called, current callState:', callState.value);
  
  // Set cancelling flag to prevent any WebSocket event handlers from changing state
  isCancelling.value = true;
  
  // CRITICAL: Reset ALL state BEFORE closing to prevent any flash
  removeSocketListeners();
  stopTimer();
  callDuration.value = 0;
  callState.value = "ready"; // Reset state first!
  
  // CRITICAL: Close dialog IMMEDIATELY after state reset
  emit('update:modelValue', false);
  
  const sessionId = callStore.sessionId;
  const roomId = callStore.roomId; // Capture roomId before endCall() clears it
  console.log('[CallDialog] sessionId from store:', sessionId);
  
  if (sessionId) {
    console.log('[CallDialog] Calling endSession for sessionId:', sessionId);
    try {
      await callApiClient.endSession(sessionId);
      console.log('[CallDialog] endSession succeeded');
    } catch (err) {
      console.error('[CallDialog] endSession failed:', err);
    }
    signalingService.notifyCallEnded(sessionId, "nurse-001");
    callStore.endCall();
    
    // Refresh call log AFTER endSession completes to get updated status
    if (roomId) {
      const patient = patientStore.patients.find((p) => p.room.roomId === roomId);
      if (patient) {
        await patientStore.refreshPatientCallLog(patient.patientId).catch(() => {});
      }
    }
  } else {
    console.warn('[CallDialog] No sessionId found in store - call may not have been created yet');
  }
  
  // Reset cancelling flag after cleanup completes
  isCancelling.value = false;
};

const handleCallAgain = async () => {
  await primeCallAudioContext();
  callAttempts.value++;
  callState.value = "calling";
  startTimer();
  registerSocketListeners();
  // Re-run confirmCall to create a new session (old session already ended)
  emit("confirm");
};

const handleBreakthroughCall = () => {
  previousState.value = callState.value === "not-answered" ? "not-answered" : "ready";
  callState.value = "breakthrough";
  selectedBreakthroughReason.value = null;
};

const handleBackFromBreakthrough = () => {
  callState.value = previousState.value;
  selectedBreakthroughReason.value = null;
};

const handleReasonSelect = async (reasonId: string) => {
  if (reasonId === "other") {
    showOtherInput.value = !showOtherInput.value;
    if (showOtherInput.value) {
      selectedBreakthroughReason.value = reasonId;
    } else {
      selectedBreakthroughReason.value = null;
      otherReasonText.value = "";
    }
  } else {
    selectedBreakthroughReason.value = reasonId;
    showOtherInput.value = false;
    
    // Get readable reason text
    const reason = breakthroughReasons.find(r => r.id === reasonId)?.label || reasonId;
    
    await executeBreakthrough(reason);
  }
};

const handleOtherReasonSubmit = async () => {
  if (otherReasonText.value.trim()) {
    await executeBreakthrough(otherReasonText.value.trim());
  }
};

const executeBreakthrough = async (reason: string) => {
  // Prevent duplicate calls
  if (isBreakthroughInProgress.value) {
    console.warn('Breakthrough already in progress, ignoring duplicate call');
    return;
  }
  
  isBreakthroughInProgress.value = true;
  
  try {
    let sessionId = callStore.sessionId;
    
    // If no active session, create one first (skip incoming_call notification)
    if (!sessionId) {
      if (!props.patientInfo?.room?.roomId) {
        console.error('No patient room information available');
        errorMessage.value = 'Unable to initiate breakthrough call. Patient room information missing.';
        showError.value = true;
        isBreakthroughInProgress.value = false;
        return;
      }
      
      // Create session WITHOUT sending incoming_call (breakthrough will send breakthrough_call instead)
      const session = await callApiClient.createSession(props.patientInfo.room.roomId, {
        recordingEnabled: true,
        skipIncomingNotification: true, // Critical: Don't show Accept/Decline on patient device
      });
      
      sessionId = session.sessionId;
      
      // Join the session as nurse (get video credentials)
      const joinResponse = await callApiClient.joinSession(sessionId, 'nurse');
      
      // Set session in call store with credentials
      callStore.setSession(
        sessionId, 
        props.patientInfo.room.roomId, 
        session.provider, 
        joinResponse.session?.credentials || session.credentials
      );
      
      // Join socket.io session room to receive call events
      signalingService.joinSession(sessionId);
    } else {
      // Session already exists (from normal call flow)
      // Nurse has already joined the session, just ensure we're in the socket.io room
      signalingService.joinSession(sessionId);
    }
    
    // Call breakthrough API (notifies patient device via WebSocket with breakthrough_call event)
    await callApiClient.initiateBreakthrough(sessionId, reason);
    
    // Transition to "calling" state (dialog stays open showing "Calling [Patient]...")
    callState.value = "calling";
    startTimer();
    registerSocketListeners(); // Listen for call_accepted, call_ended events
    
    // Dialog will stay open in "calling" state until:
    // - Patient auto-connects and sends call_accepted event → onCallAccepted fires → navigates to call view
    // - Call fails or is cancelled → onCallEnded/onCallDeclined fires
    
  } catch (error) {
    console.error('Breakthrough call failed:', error);
    errorMessage.value = 'Failed to initiate breakthrough call. Please try again.';
    showError.value = true;
    isBreakthroughInProgress.value = false;
    
    // Reset to previous state on error
    callState.value = previousState.value;
    stopTimer();
    
    // Reset form state
    selectedBreakthroughReason.value = null;
    showOtherInput.value = false;
    otherReasonText.value = "";
  }
};

const toggleCallDetails = () => {
  callDetailsExpanded.value = !callDetailsExpanded.value;
};

const handleLeaveFeedback = () => {
  feedbackExpanded.value = true;
};

const handleSubmitFeedback = () => {
  if (feedbackText.value.trim()) {
    console.log("Feedback submitted:", feedbackText.value);
    emit("update:modelValue", false);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue && !isCancelling.value,
    "max-width": ['calling', 'not-answered', 'breakthrough', 'completed'].includes(callState.value) ? '510' : '568',
    persistent: "",
    "onUpdate:modelValue": handleClose
  }, {
    default: _withCtx(() => [
      (isCancelling.value)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            class: "call-dialog",
            style: {"height":"0","overflow":"hidden"}
          }))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            class: _normalizeClass(["call-dialog", {
        'call-dialog--calling': callState.value === 'calling',
        'call-dialog--not-answered': callState.value === 'not-answered',
        'call-dialog--breakthrough': callState.value === 'breakthrough',
        'call-dialog--completed': callState.value === 'completed',
      }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                size: "default",
                class: "call-dialog__close-btn",
                onClick: handleClose
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "24",
                    color: "#222222"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (callState.value === 'calling')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "call-dialog__calling-avatar-pulse" }, null, -1)),
                          _createElementVNode("div", _hoisted_5, _toDisplayString(patientInitials.value), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h3", _hoisted_7, "Calling " + _toDisplayString(__props.patientInfo?.patientName?.split(" ")[0]) + "...", 1),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "call-dialog__calling-status" }, "Waiting for them to accept", -1)),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(formattedDuration.value), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (callState.value === 'calling')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    size: "large",
                    rounded: "pill",
                    class: "call-dialog__cancel-btn",
                    onClick: handleCancelCall
                  }, {
                    default: _withCtx(() => [
                      _cache[8] || (_cache[8] = _createTextVNode(" Cancel Call ", -1)),
                      _createVNode(_component_v_icon, {
                        end: "",
                        size: "24",
                        color: "#FFFFFF"
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (callState.value === 'breakthrough')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      ref_key: "breakthroughStateRef",
                      ref: breakthroughStateRef,
                      class: "call-dialog__breakthrough-state"
                    }, [
                      _createVNode(_component_v_btn, {
                        icon: "",
                        variant: "text",
                        size: "default",
                        class: "call-dialog__back-btn",
                        onClick: handleBackFromBreakthrough
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "24",
                            color: "#222222"
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode("mdi-arrow-left", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_v_icon, {
                            size: "82",
                            color: "#D79D17"
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("mdi-alert-circle", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "call-dialog__breakthrough-warning" }, [
                          _createTextVNode(" Breakthrough immediately connects to patient device."),
                          _createElementVNode("br"),
                          _createTextVNode(" Overrides quiet hours and patient settings. ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "call-dialog__breakthrough-label" }, "Select reason for override", -1)),
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(breakthroughReasons, (reason) => {
                              return _createElementVNode("div", {
                                key: reason.id
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    'call-dialog__breakthrough-option',
                    { 
                      'call-dialog__breakthrough-option--selected': selectedBreakthroughReason.value === reason.id,
                      'call-dialog__breakthrough-option--disabled': isBreakthroughInProgress.value
                    },
                  ]),
                                  role: "button",
                                  tabindex: "0",
                                  onClick: ($event: any) => (!isBreakthroughInProgress.value && handleReasonSelect(reason.id)),
                                  onKeydown: [
                                    _withKeys(($event: any) => (!isBreakthroughInProgress.value && handleReasonSelect(reason.id)), ["enter"]),
                                    _withKeys(_withModifiers(($event: any) => (!isBreakthroughInProgress.value && handleReasonSelect(reason.id)), ["prevent"]), ["space"])
                                  ]
                                }, [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(reason.label), 1),
                                  (!isBreakthroughInProgress.value)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        size: "24",
                                        color: "#291758"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(reason.id === "other"
                        ? showOtherInput.value
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                        : "mdi-chevron-right"), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (selectedBreakthroughReason.value === reason.id && reason.id !== 'other')
                                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                          key: 1,
                                          indeterminate: "",
                                          size: "20",
                                          width: "2",
                                          color: "primary"
                                        }))
                                      : _createCommentVNode("", true)
                                ], 42, _hoisted_13),
                                _createVNode(_component_v_expand_transition, null, {
                                  default: _withCtx(() => [
                                    (reason.id === 'other' && showOtherInput.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          _createVNode(_component_v_text_field, {
                                            modelValue: otherReasonText.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otherReasonText).value = $event)),
                                            variant: "outlined",
                                            density: "comfortable",
                                            placeholder: "Enter custom reason...",
                                            "hide-details": "",
                                            class: "call-dialog__other-input",
                                            disabled: isBreakthroughInProgress.value
                                          }, null, 8, ["modelValue", "disabled"]),
                                          _createVNode(_component_v_expand_transition, null, {
                                            default: _withCtx(() => [
                                              (otherReasonText.value.trim())
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 0,
                                                    size: "large",
                                                    rounded: "pill",
                                                    class: "call-dialog__continue-btn",
                                                    loading: isBreakthroughInProgress.value,
                                                    disabled: isBreakthroughInProgress.value,
                                                    onClick: handleOtherReasonSubmit
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                      _createTextVNode(" Continue ", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["loading", "disabled"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            }), 64))
                          ])
                        ])
                      ])
                    ], 512))
                  : (callState.value === 'completed')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("h3", _hoisted_18, "Call log: Room " + _toDisplayString(__props.patientInfo?.room.roomNumber), 1),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(__props.patientInfo?.patientName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: "call-dialog__status-badge",
                            style: _normalizeStyle({ backgroundColor: statusBadgeColor.value, color: statusBadgeTextColor.value })
                          }, _toDisplayString(displayReason.value), 5),
                          (__props.patientInfo?.dischargeOrderTime)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Discharge order: " + _toDisplayString(formatDischargeTime.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", {
                              class: "call-dialog__section-header",
                              role: "button",
                              tabindex: "0",
                              onClick: toggleCallParticipants,
                              onKeydown: [
                                _withKeys(toggleCallParticipants, ["enter"]),
                                _withKeys(_withModifiers(toggleCallParticipants, ["prevent"]), ["space"])
                              ]
                            }, [
                              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "call-dialog__section-header-left" }, [
                                _createElementVNode("span", { class: "call-dialog__section-title" }, "CALL PARTICIPANTS"),
                                _createElementVNode("div", { class: "call-dialog__badge" }, "2")
                              ], -1)),
                              _createVNode(_component_v_icon, {
                                size: "16",
                                color: "#6A5D8A"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(callParticipantsExpanded.value ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
                                ]),
                                _: 1
                              })
                            ], 40, _hoisted_24),
                            _createVNode(_component_v_expand_transition, null, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, _toDisplayString(patientInitials.value), 1),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, _toDisplayString(__props.patientInfo?.patientName), 1),
                                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "call-dialog__participant-role" }, "Patient", -1))
                                    ])
                                  ]),
                                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "call-dialog__completed-participant" }, [
                                    _createElementVNode("div", { class: "call-dialog__avatar call-dialog__avatar--nurse" }, "AM"),
                                    _createElementVNode("div", { class: "call-dialog__participant-info" }, [
                                      _createElementVNode("div", { class: "call-dialog__participant-name" }, "Alex Mendez"),
                                      _createElementVNode("div", { class: "call-dialog__participant-role" }, "RN (You)")
                                    ])
                                  ], -1))
                                ], 512), [
                                  [_vShow, callParticipantsExpanded.value]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", {
                              class: "call-dialog__section-header",
                              role: "button",
                              tabindex: "0",
                              onClick: toggleCallDetails,
                              onKeydown: [
                                _withKeys(toggleCallDetails, ["enter"]),
                                _withKeys(_withModifiers(toggleCallDetails, ["prevent"]), ["space"])
                              ]
                            }, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "call-dialog__section-title" }, "CALL DETAILS", -1)),
                              _createVNode(_component_v_icon, {
                                size: "16",
                                color: "#6A5D8A"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(callDetailsExpanded.value ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
                                ]),
                                _: 1
                              })
                            ], 40, _hoisted_31),
                            _createVNode(_component_v_expand_transition, null, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "call-dialog__detail-label" }, "Attempt Count", -1)),
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(callAttempts.value), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_35, [
                                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "call-dialog__detail-label" }, "Timestamp", -1)),
                                    _createElementVNode("div", _hoisted_36, "Today, " + _toDisplayString(callStartTime.value), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "call-dialog__detail-label" }, "Call duration", -1)),
                                    _createElementVNode("div", _hoisted_38, _toDisplayString(formattedCallDurationFull.value), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "call-dialog__detail-label" }, "Outcome", -1)),
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(callOutcome.value), 1)
                                  ])
                                ], 512), [
                                  [_vShow, callDetailsExpanded.value]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_41, [
                            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "call-dialog__section-header" }, [
                              _createElementVNode("span", { class: "call-dialog__section-title" }, "FEEDBACK")
                            ], -1)),
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_v_textarea, {
                                modelValue: feedbackText.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((feedbackText).value = $event)),
                                variant: "outlined",
                                placeholder: "Share your feedback about this call...",
                                "hide-details": "",
                                rows: "3",
                                "no-resize": "",
                                class: "call-dialog__feedback-textarea"
                              }, null, 8, ["modelValue"])
                            ])
                          ], 512), [
                            [_vShow, feedbackExpanded.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          (!feedbackExpanded.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _createVNode(_component_v_btn, {
                                  variant: "outlined",
                                  rounded: "pill",
                                  size: "default",
                                  class: "call-dialog__feedback-btn",
                                  onClick: handleLeaveFeedback
                                }, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode(" Leave Feedback ", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createVNode(_component_v_btn, {
                                  variant: "outlined",
                                  rounded: "pill",
                                  size: "default",
                                  class: "call-dialog__close-btn-footer",
                                  onClick: handleClose
                                }, {
                                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                    _createTextVNode(" Close ", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_v_btn, {
                                  rounded: "pill",
                                  size: "default",
                                  class: "call-dialog__submit-btn",
                                  disabled: !feedbackText.value.trim(),
                                  onClick: handleSubmitFeedback
                                }, {
                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                    _createTextVNode(" Submit ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]))
                        ])
                      ]))
                    : (callState.value === 'not-answered')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_v_icon, {
                                size: "82",
                                color: "#7F8287"
                              }, {
                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                  _createTextVNode("mdi-minus-circle-outline", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "call-dialog__not-answered-title" }, "No Answer", -1)),
                              _createElementVNode("div", _hoisted_50, [
                                _createTextVNode(" Call attempt #" + _toDisplayString(callAttempts.value) + " logged", 1),
                                _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(" Duration: " + _toDisplayString(formattedCallDuration.value) + " • " + _toDisplayString(callEndTime.value), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_v_btn, {
                              size: "large",
                              rounded: "pill",
                              class: "call-dialog__call-again-btn",
                              onClick: handleCallAgain
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  start: "",
                                  size: "24",
                                  color: "#FFFFFF"
                                }, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createTextVNode("mdi-bell-ring-outline", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[31] || (_cache[31] = _createTextVNode(" Call Again ", -1)),
                                _createVNode(_component_v_icon, {
                                  end: "",
                                  size: "20",
                                  color: "#FFFFFF"
                                }, {
                                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                    _createTextVNode("mdi-arrow-right", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_v_btn, {
                                size: "large",
                                rounded: "pill",
                                class: "call-dialog__breakthrough-btn",
                                onClick: handleBreakthroughCall
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    start: "",
                                    size: "24",
                                    color: "#222222"
                                  }, {
                                    default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                      _createTextVNode("mdi-lock-open-remove", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[34] || (_cache[34] = _createTextVNode(" Breakthrough ", -1)),
                                  _createVNode(_component_v_icon, {
                                    end: "",
                                    size: "20",
                                    color: "#222222"
                                  }, {
                                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                      _createTextVNode("mdi-arrow-right", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "call-dialog__breakthrough-text" }, [
                                _createTextVNode(" Breakthrough immediately connects to patient device."),
                                _createElementVNode("br"),
                                _createTextVNode(" Overrides quiet hours and patient settings. ")
                              ], -1))
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("h2", _hoisted_55, "Call patient in Room " + _toDisplayString(__props.patientInfo?.room.roomNumber), 1),
                            _createElementVNode("div", _hoisted_56, _toDisplayString(__props.patientInfo?.patientName), 1),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", {
                                class: "call-dialog__status-badge",
                                style: _normalizeStyle({ backgroundColor: statusBadgeColor.value, color: statusBadgeTextColor.value })
                              }, _toDisplayString(displayReason.value), 5),
                              (__props.patientInfo?.dischargeOrderTime)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, " Discharge order: " + _toDisplayString(formatDischargeTime.value), 1))
                                : _createCommentVNode("", true),
                              (__props.patientInfo?.isOverdue)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createVNode(_component_v_icon, {
                                      size: "16",
                                      color: "#FFFFFF"
                                    }, {
                                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                        _createTextVNode("mdi-alert-circle", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(overdueMinutes.value) + " overdue", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_v_alert, {
                              type: "info",
                              variant: "tonal",
                              class: "call-dialog__alert",
                              density: "comfortable"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                    _createTextVNode("mdi-information", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "call-dialog__alert-text" }, "Spanish Interpreter Required", -1))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", {
                                class: "call-dialog__section-header",
                                role: "button",
                                tabindex: "0",
                                onClick: toggleCallParticipants,
                                onKeydown: [
                                  _withKeys(toggleCallParticipants, ["enter"]),
                                  _withKeys(_withModifiers(toggleCallParticipants, ["prevent"]), ["space"])
                                ]
                              }, [
                                _cache[39] || (_cache[39] = _createElementVNode("div", { class: "call-dialog__section-header-left" }, [
                                  _createElementVNode("span", { class: "call-dialog__section-title" }, "CALL PARTICIPANTS"),
                                  _createElementVNode("div", { class: "call-dialog__badge" }, "2")
                                ], -1)),
                                _createVNode(_component_v_icon, {
                                  size: "20",
                                  color: "#6A5D8A"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(callParticipantsExpanded.value ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
                                  ]),
                                  _: 1
                                })
                              ], 40, _hoisted_62),
                              _createVNode(_component_v_expand_transition, null, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          _createElementVNode("div", _hoisted_66, _toDisplayString(patientInitials.value), 1),
                                          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "call-dialog__status-dot" }, null, -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_67, [
                                          _createElementVNode("div", _hoisted_68, _toDisplayString(__props.patientInfo?.patientName), 1),
                                          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "call-dialog__participant-role" }, "Patient", -1))
                                        ]),
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          variant: "text",
                                          size: "small",
                                          disabled: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "20" }, {
                                              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                                _createTextVNode("mdi-microphone", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_69, [
                                        _createElementVNode("div", _hoisted_70, [
                                          _createElementVNode("div", _hoisted_71, _toDisplayString(currentUserInitials.value), 1),
                                          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "call-dialog__status-dot" }, null, -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_72, [
                                          _createElementVNode("div", _hoisted_73, _toDisplayString(currentUserDisplayName.value), 1),
                                          _cache[44] || (_cache[44] = _createElementVNode("div", { class: "call-dialog__participant-role" }, "RN (You)", -1))
                                        ]),
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          variant: "text",
                                          size: "small",
                                          disabled: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "20" }, {
                                              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                                _createTextVNode("mdi-microphone", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_74, [
                                      _createVNode(_component_v_btn, {
                                        variant: "flat",
                                        size: "small",
                                        rounded: "pill",
                                        class: "call-dialog__add-btn"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            start: "",
                                            size: "20"
                                          }, {
                                            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                              _createTextVNode("mdi-account-multiple", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _cache[47] || (_cache[47] = _createTextVNode(" Add Staff ", -1))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_btn, {
                                        variant: "flat",
                                        size: "small",
                                        rounded: "pill",
                                        class: "call-dialog__add-btn"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            start: "",
                                            size: "20"
                                          }, {
                                            default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                              _createTextVNode("mdi-translate", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _cache[49] || (_cache[49] = _createTextVNode(" Add Interpreter ", -1))
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ], 512), [
                                    [_vShow, callParticipantsExpanded.value]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", {
                                class: "call-dialog__section-header",
                                role: "button",
                                tabindex: "0",
                                onClick: toggleCarePartners,
                                onKeydown: [
                                  _withKeys(toggleCarePartners, ["enter"]),
                                  _withKeys(_withModifiers(toggleCarePartners, ["prevent"]), ["space"])
                                ]
                              }, [
                                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "call-dialog__section-header-left" }, [
                                  _createElementVNode("span", { class: "call-dialog__section-title" }, "CARE PARTNERS"),
                                  _createElementVNode("div", { class: "call-dialog__badge" }, "2")
                                ], -1)),
                                _createVNode(_component_v_icon, {
                                  size: "20",
                                  color: "#6A5D8A"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(carePartnersExpanded.value ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
                                  ]),
                                  _: 1
                                })
                              ], 40, _hoisted_76),
                              _createVNode(_component_v_expand_transition, null, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_77, [
                                      _createElementVNode("div", _hoisted_78, [
                                        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "call-dialog__avatar" }, "AJ", -1)),
                                        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "call-dialog__participant-info" }, [
                                          _createElementVNode("div", { class: "call-dialog__participant-name" }, "Andrew Johnson"),
                                          _createElementVNode("div", { class: "call-dialog__participant-role" }, "Husband")
                                        ], -1)),
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          variant: "text",
                                          size: "small",
                                          disabled: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "20" }, {
                                              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                                _createTextVNode("mdi-phone", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_79, [
                                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "call-dialog__avatar" }, "GF", -1)),
                                        _cache[56] || (_cache[56] = _createElementVNode("div", { class: "call-dialog__participant-info" }, [
                                          _createElementVNode("div", { class: "call-dialog__participant-name" }, "Gabrielle Franco"),
                                          _createElementVNode("div", { class: "call-dialog__participant-role" }, "Daughter")
                                        ], -1)),
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          variant: "text",
                                          size: "small",
                                          disabled: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "20" }, {
                                              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                                _createTextVNode("mdi-phone", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_80, [
                                      _createVNode(_component_v_btn, {
                                        variant: "flat",
                                        size: "small",
                                        rounded: "pill",
                                        class: "call-dialog__add-btn"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            start: "",
                                            size: "20"
                                          }, {
                                            default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                              _createTextVNode("mdi-account-multiple", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _cache[58] || (_cache[58] = _createTextVNode(" Add Care Partner ", -1))
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ], 512), [
                                    [_vShow, carePartnersExpanded.value]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])),
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_v_btn, {
                  size: "large",
                  rounded: "pill",
                  class: "call-dialog__call-btn",
                  onClick: handleConfirm
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      start: "",
                      color: "#FFFFFF",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                        _createTextVNode("mdi-bell-ring-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[61] || (_cache[61] = _createTextVNode(" Call Now ", -1)),
                    _createVNode(_component_v_icon, {
                      end: "",
                      color: "#FFFFFF",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                        _createTextVNode("mdi-arrow-right", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["class"])),
      _createVNode(_component_v_snackbar, {
        modelValue: showError.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showError).value = $event)),
        color: "error",
        timeout: "6000",
        location: "top"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false))
          }, {
            default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
              _createTextVNode(" Close ", -1)
            ]))]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
              _createTextVNode("mdi-alert-circle", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(errorMessage.value) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["model-value", "max-width"]))
}
}

})